import React from 'react';
import * as S from './componentes/styles';
import DataPDF from './componentes/data'
import PagePDF from './componentes/PagePDF'

function FooterPDF(){
    return(
        <>
        <S.Container>
          <DataPDF />
            
            <S.AlignItens>
                <PagePDF page="1/2"/>
                <S.CardANS>
                    ANS nº 359017
                </S.CardANS>
            </S.AlignItens>

        </S.Container>
      </>
    )
} 

export default FooterPDF;